module.exports = __webpack_public_path__ + "img/H03097-01.7ba012ee.jpg";